(function () {
  function getCartItems(cartItems) {
    return cartItems.map(function (item) {
      return {
        item_id: item.sku || String(item.variant_id || item.id),
        item_name: item.product_title || item.title,
        item_variant: (item.variant_title && item.variant_title !== 'Default Title') ? item.variant_title : undefined,
        item_brand: item.vendor,
        price: item.price / 100,
        quantity: item.quantity
      };
    });
  }

  // view_item / view_item_list
  const gtmData = window.pdiGtmData;
  if (gtmData) {
    window.dataLayer = window.dataLayer || [];
    if (gtmData.template === 'product' && gtmData.product) {
      const p = gtmData.product;
      const variantTitle = (p.variant_title && p.variant_title !== 'Default Title') ? p.variant_title : undefined;
      window.dataLayer.push({ ecommerce: null });
      window.dataLayer.push({
        event: 'view_item',
        ecommerce: {
          currency: window.Shopify?.currency?.active ?? 'USD',
          value: p.price / 100,
          items: [{
            item_id: p.sku || String(p.variant_id),
            item_name: p.title,
            item_brand: p.vendor,
            item_variant: variantTitle,
            price: p.price / 100,
            quantity: 1
          }]
        }
      });
    } else if (gtmData.template === 'collection' && gtmData.collection_items?.length) {
      window.dataLayer.push({ ecommerce: null });
      window.dataLayer.push({
        event: 'view_item_list',
        ecommerce: {
          item_list_name: gtmData.collection,
          items: gtmData.collection_items
        }
      });
    }
  }

  // add_to_cart
  document.addEventListener('product-ajax:added', function (e) {
    const product = e.detail?.product;
    if (!product) return;

    const items = product.items
      ? getCartItems(product.items)
      : getCartItems([product]);

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ ecommerce: null });
    window.dataLayer.push({
      event: 'add_to_cart',
      ecommerce: {
        currency: window.Shopify?.currency?.active ?? 'USD',
        value: items.reduce(function (sum, item) { return sum + item.price * item.quantity; }, 0),
        items: items
      }
    });
  });

  // video_play
  document.addEventListener('video:play', function (e) {
    const videoEl = e.target;
    if (!videoEl) return;
    const btn = videoEl.querySelector('.media__poster');
    const videoId = btn ? (btn.id || '').replace('DeferredPoster-', '') : '';
    const imgAlt = videoEl.querySelector('img')?.alt || '';
    const videoTitle = imgAlt.replace('Load video: ', '').replace('Play video: ', '');
    const sourceAttr = videoEl.getAttribute('source');
    const videoProvider = sourceAttr && sourceAttr.trim() ? sourceAttr.trim() : 'html5';
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'video_play',
      video_provider: videoProvider,
      video_id: videoId,
      video_title: videoTitle
    });
  });

  // content_card_click
  document.addEventListener('click', function (e) {
    const link = e.target.closest('.content-card-global a[href]');
    if (!link) return;
    const card = link.closest('.content-card-global');
    const linkText = card.querySelector('.icon-button')?.textContent || '';
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'content_card_click',
      link_text: linkText.trim(),
      link_url: link.getAttribute('href')
    });
  });

  // schedule_consultation
  document.addEventListener('click', function (e) {
    const link = e.target.closest('a[href="/pages/book-an-appointment"]');
    if (!link) return;
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'schedule_consultation',
      link_text: link.textContent.trim(),
      link_url: link.getAttribute('href')
    });
  });

  // header_cta_click
  document.addEventListener('click', function (e) {
    const link = e.target.closest('.secondary-unauthenticated a[href]');
    if (!link) return;
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'header_cta_click',
      link_text: link.textContent.trim(),
      link_url: link.getAttribute('href')
    });
  });

  function isPdfLink(href) {
    if (!href) return false;
    try {
      return new URL(href, window.location.href).pathname.toLowerCase().endsWith('.pdf');
    } catch (_e) {
      return false;
    }
  }

  // pdf_download
  document.addEventListener('click', function (e) {
    const link = e.target.closest('a[href]');
    if (!link) return;
    const href = link.getAttribute('href') || '';
    if (!isPdfLink(href)) return;
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'pdf_download',
      link_text: link.textContent.trim(),
      link_url: href
    });
  });

  // store_locator_view
  if (window.location.pathname.startsWith('/pages/') && document.querySelector('store-locator')) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ ecommerce: null });
    window.dataLayer.push({ event: 'store_locator_view' });
  }

  // store_locator_search (Find Now button)
  document.addEventListener('click', function (e) {
    const submitBtn = e.target.closest('.store-locator__filters-submit');
    const locatorEl = submitBtn?.closest('store-locator');
    if (!submitBtn || !locatorEl) return;

    const zip = locatorEl.querySelector('input[name="zip"]')?.value || '';
    const radius = locatorEl.querySelector('select[name="radius"]')?.value || '';

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'store_locator_search',
      search_term: zip,
      search_radius: radius
    });
  });

  // sign_up — registration modal open
  document.addEventListener('click', function (e) {
    const trigger = e.target.closest('[href="#Register"],[data-registration-trigger]');
    if (!trigger) return;
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: 'sign_up', method: 'registration_modal' });
  });

  // trade_account_signup — join program modal open
  document.addEventListener('click', function (e) {
    const trigger = e.target.closest('[href="#JoinProgram"],[data-join-program-trigger]');
    if (!trigger) return;
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: 'trade_account_signup' });
  });

  // form_submit — registration & trade pro modals (shadow DOM direct attach)
  function attachFormSubmitListener(modalId, formName, formId) {
    const modal = document.getElementById(modalId);
    if (!modal) return;

    const embedEl = modal.querySelector('shopify-forms-embed');
    if (!embedEl) return;

    const shadowRoot = embedEl.shadowRoot;
    if (!shadowRoot) return;

    function tryAttach() {
      const form = shadowRoot.querySelector('form[data-testid="form"]');
      if (!form || form._pdiListenerAttached) return;
      form._pdiListenerAttached = true;
      form.addEventListener('submit', function () {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'form_submit',
          form_name: formName,
          form_id: formId
        });
      });
    }

    const observer = new MutationObserver(function () {
      tryAttach();
    });

    observer.observe(shadowRoot, { childList: true, subtree: true });
    tryAttach();
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[href="#Register"],[data-registration-trigger]')) {
      setTimeout(function () {
        attachFormSubmitListener('registration-modal', 'Trade Customer Registration', '783431');
      }, 300);
    }
    if (e.target.closest('[href="#JoinProgram"],[data-join-program-trigger]')) {
      setTimeout(function () {
        attachFormSubmitListener('join-program-modal', 'PDI Trade Pro Program', '801734');
      }, 300);
    }
  });

  // add_to_wishlist
  document.addEventListener('click', function (e) {
    // Individual item heart
    const saveBtn = e.target.closest('.save-product');
    if (saveBtn?.dataset.variantId) {
      const variantId = String(saveBtn.dataset.variantId);
      fetch('/cart.js')
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          const item = cart.items.find(function (i) { return String(i.variant_id) === variantId; });
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({ ecommerce: null });
          window.dataLayer.push({
            event: 'add_to_wishlist',
            ecommerce: {
              currency: cart.currency,
              value: item ? item.price / 100 : 0,
              items: item ? [{
                item_id: item.sku || variantId,
                item_name: item.product_title,
                item_variant: (item.variant_title && item.variant_title !== 'Default Title') ? item.variant_title : undefined,
                item_brand: item.vendor,
                price: item.price / 100,
                quantity: 1
              }] : [{ item_id: variantId }]
            }
          });
        })
        .catch(function () {});
      return;
    }

    // Save entire cart heart
    const cartSaveBtn = e.target.closest('.aasaved-cart-trigger');
    if (cartSaveBtn) {
      fetch('/cart.js')
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          if (!cart.items.length) return;
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({ ecommerce: null });
          window.dataLayer.push({
            event: 'add_to_wishlist',
            ecommerce: {
              currency: cart.currency,
              value: cart.total_price / 100,
              items: getCartItems(cart.items)
            }
          });
        })
        .catch(function () {});
    }
  });

  // remove_from_cart
  (function () {
    function processCartRemoval(cart, body) {
      let item;
      if (body.line !== undefined) {
        item = cart.items[body.line - 1];
      } else if (body.id) {
        item = cart.items.find(function (i) { return i.variant_id == body.id; });
      }
      if (!item) return;
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ ecommerce: null });
      window.dataLayer.push({
        event: 'remove_from_cart',
        ecommerce: {
          currency: cart.currency,
          value: (item.price / 100) * item.quantity,
          items: [{
            item_id: item.sku || String(item.variant_id),
            item_name: item.product_title,
            item_variant: (item.variant_title && item.variant_title !== 'Default Title') ? item.variant_title : undefined,
            item_brand: item.vendor,
            price: item.price / 100,
            quantity: item.quantity
          }]
        }
      });
    }

    const _fetch = window.fetch;
    window.fetch = function (input, init) {
      const url = typeof input === 'string' ? input : input?.url;
      if (url && url.includes('/cart/change') && init?.body) {
        try {
          const body = JSON.parse(init.body);
          if (body.quantity === 0) {
            _fetch('/cart.js')
              .then(function (r) { return r.json(); })
              .then(function (cart) { processCartRemoval(cart, body); });
          }
        } catch (_e) { /* intentionally empty — invalid JSON body is not an error */ }
      }
      return _fetch.apply(this, arguments);
    };
  })();

  // begin_checkout
  document.addEventListener('click', function (e) {
    const btn = e.target.closest('[name="checkout"]');
    if (!btn) return;

    e.preventDefault();
    e.stopImmediatePropagation();

    const form = btn.form || document.getElementById('cart');

    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ ecommerce: null });
        window.dataLayer.push({
          event: 'begin_checkout',
          ecommerce: {
            currency: cart.currency,
            value: cart.total_price / 100,
            items: getCartItems(cart.items)
          }
        });
      })
      .catch(function () {})
      .finally(function () {
        if (form) {
          let hidden = form.querySelector('input[name="checkout"][type="hidden"]');
          if (!hidden) {
            hidden = document.createElement('input');
            hidden.type = 'hidden';
            hidden.name = 'checkout';
            form.appendChild(hidden);
          }
          hidden.value = '';
          form.submit();
        } else {
          window.location.href = '/checkout';
        }
      });
  }, true);
})();
